namespace GeniuzPOS.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}
